import { LicensedPartners as LicensedPartnersContent } from '#src/LicensedPartners/index.tsx';

const LicensedPartersBySport = () => {
  return <LicensedPartnersContent />;
};

export default LicensedPartersBySport;
